// Свои окна вместо prompt()/confirm() браузера: ввод строки и подтверждение.
// Использование из любой функции: await askText({title, label, value}) -> строка | undefined;
// await askConfirm({title, text, ok, danger}) -> true | undefined. Диалоги 'ui.prompt' / 'ui.confirm'
// регистрирует функция shell.
import { useState } from 'react';
import type { DialogProps } from '../core/registry';
import { ctx } from '../core/ctx';
import { Btn, Field, Modal } from './controls';

export interface AskTextOpts { title: string; label?: string; value?: string; placeholder?: string; hint?: string; ok?: string;
  /** варианты для быстрого выбора (например, подписи версий) */
  presets?: string[]; multiline?: boolean; allowEmpty?: boolean; testid?: string }
export interface ConfirmOpts { title: string; text?: string; ok?: string; cancel?: string; danger?: boolean; testid?: string }

export const askText = (o: AskTextOpts) => ctx.openDialog<string>('ui.prompt', o as unknown as Record<string, unknown>);
export const askConfirm = (o: ConfirmOpts) => ctx.openDialog<boolean>('ui.confirm', o as unknown as Record<string, unknown>);

export function PromptDialog({ props, close }: DialogProps<string>) {
  const o = props as AskTextOpts;
  const [v, setV] = useState(o.value ?? '');
  const ok = () => { if (o.allowEmpty || v.trim()) close(v); };
  return (
    <Modal title={o.title} onClose={() => close()} width={480} testid={o.testid || 'prompt-dialog'} footer={<>
      <Btn label="Отмена" onClick={() => close()} />
      <Btn label={o.ok || 'ОК'} primary onClick={ok} disabled={!o.allowEmpty && !v.trim()} testid="prompt-ok" />
    </>}>
      <Field label={o.label || ''} hint={o.hint} wide>
        {o.multiline
          ? <textarea rows={4} value={v} onChange={(e) => setV(e.target.value)} placeholder={o.placeholder} data-testid="prompt-input"
            onKeyDown={(e) => { if (e.key === 'Enter' && e.ctrlKey) ok(); }} />
          : <input value={v} onChange={(e) => setV(e.target.value)} placeholder={o.placeholder} data-testid="prompt-input"
            onFocus={(e) => e.target.select()} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); ok(); } }} />}
      </Field>
      {o.presets?.length ? (
        <div className="chips">
          {o.presets.map((p) => <button key={p} type="button" className="chip" onClick={() => setV(p)}>{p}</button>)}
        </div>
      ) : null}
    </Modal>
  );
}

export function ConfirmDialog({ props, close }: DialogProps<boolean>) {
  const o = props as ConfirmOpts;
  return (
    <Modal title={o.title} onClose={() => close()} width={460} testid={o.testid || 'confirm-dialog'} footer={<>
      <Btn label={o.cancel || 'Отмена'} onClick={() => close()} testid="confirm-cancel" />
      <button type="button" data-autofocus className={'btn ' + (o.danger ? 'btn-danger-solid' : 'btn-primary')} data-testid="confirm-ok"
        onClick={() => close(true)}>{o.ok || 'ОК'}</button>
    </>}>
      {o.text && <p className="confirm-text">{o.text}</p>}
    </Modal>
  );
}
